/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_General_Use_Local_StorageInputs */

const en_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use Local Storage`)
};

const fr_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utiliser le stockage local`)
};

const de_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalen Speicher verwenden`)
};

const it_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utilizza l'archiviazione locale`)
};

const ru_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Использовать локальное хранилище`)
};

const es_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar almacenamiento local`)
};

const zh_cn2_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用本地存储`)
};

const ja_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ローカルストレージを使用する`)
};

const hi_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थानीय संग्रहण का उपयोग करें`)
};

const pt_pt2_options_general_use_local_storage = /** @type {(inputs: Options_General_Use_Local_StorageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usar armazenamento local`)
};

/**
* | output |
* | --- |
* | "Use Local Storage" |
*
* @param {Options_General_Use_Local_StorageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_general_use_local_storage = /** @type {((inputs?: Options_General_Use_Local_StorageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_General_Use_Local_StorageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_general_use_local_storage(inputs)
	if (locale === "de") return de_options_general_use_local_storage(inputs)
	if (locale === "it") return it_options_general_use_local_storage(inputs)
	if (locale === "ru") return ru_options_general_use_local_storage(inputs)
	if (locale === "es") return es_options_general_use_local_storage(inputs)
	if (locale === "zh-CN") return zh_cn2_options_general_use_local_storage(inputs)
	if (locale === "ja") return ja_options_general_use_local_storage(inputs)
	if (locale === "hi") return hi_options_general_use_local_storage(inputs)
	if (locale === "pt-PT") return pt_pt2_options_general_use_local_storage(inputs)
	return en_options_general_use_local_storage(inputs)
});